import { SubmissionError } from 'redux-form';
import apiV2ErrorTranslations from 'ha/constants/apiV2ErrorTranslations';

const translationKeyOrDefault = message =>
  apiV2ErrorTranslations[message] || message;

export default function normalizeApiV2Errors(T, err) {
  const apiErrors =
    (err && err.cause && err.cause.response && err.cause.response.errors) ||
    null;

  if (!apiErrors) {
    return new SubmissionError({
      _error: T(translationKeyOrDefault(err.message)),
    });
  }

  const errors = apiErrors.reduce((acc, error) => {
    if (!error.key) {
      // eslint-disable-next-line no-underscore-dangle
      acc._error = T(translationKeyOrDefault(error.detail));
    } else {
      acc[error.key] = T(translationKeyOrDefault(error.detail));
    }

    return acc;
  }, {});

  return new SubmissionError(errors);
}
